import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { EnumerationItem } from "projects/shared/models/enumeration-item.model";
import { Borrower, MilitaryServicePeriod } from "../../models/borrower-model";
import { EnumsService } from "../../services/enums.service";

@Component({
    selector: 'borrower-military-service',
    templateUrl: 'borrower-military-service.component.html',
    styleUrls: ['./borrower-military-service.component.scss'],
    standalone: false
})
export class BorrowerMilitaryServiceComponent implements OnInit {

  @ViewChild('militaryServiceForm') militaryServiceForm: NgForm | undefined;

  @Input()
  borrower!: Borrower;

  militaryStatusTypes: EnumerationItem[] = [];

  militaryBranchOfServiceTypes: EnumerationItem[] = [];

  constructor(private readonly _enumsService: EnumsService) {
    this.militaryStatusTypes = this._enumsService.militaryStatusTypes;
    this.militaryBranchOfServiceTypes = this._enumsService.militaryBranchOfServiceTypes;
  }

  ngOnInit(): void {
    if (!this.borrower.militaryServicePeriods) {
      this.borrower.militaryServicePeriods = [];
    }
    if (this.borrower.hasServedInMilitary && this.borrower.militaryServicePeriods.length === 0) {
      this.migrateExistingDataToPeriod();
    }
  }

  onHasServedInMilitaryChanged = () => {
    if (this.borrower.hasServedInMilitary) {
      if (!this.borrower.militaryServicePeriods || this.borrower.militaryServicePeriods.length === 0) {
        this.borrower.militaryServicePeriods = [];
        this.addServicePeriod();
      }
    } else {
      this.borrower.militaryServicePeriods = [];
      this.borrower.isActiveDutyMilitary = false;
      this.borrower.onlyNonActivatedReserveOrNationalGuard = false;
      this.borrower.isRetiredDischargedSeparatedFromMilitary = false;
      this.borrower.militaryTourEndDate = "";
      this.borrower.isFirstUseOfVaBenefit = false;
      this.borrower.isVaFundingFeeExempt = false;
      this.borrower.isSurvivingSpouseOfMilitary = false;
    }
  }

  onMilitaryStatusChanged = (period: MilitaryServicePeriod, index: number) => {
    if (index === 0) {
      this.syncBorrowerFlagsFromFirstPeriod(period);
    }
  }

  onBranchOfServiceChanged = (period: MilitaryServicePeriod) => {
    if (period.branchOfService !== 'Other') {
      period.branchOfServiceOtherDescription = undefined;
    }
  }

  addServicePeriod = () => {
    const period = new MilitaryServicePeriod();
    period.borrowerId = this.borrower.borrowerId || 0;
    this.borrower.militaryServicePeriods.push(period);
  }

  removeServicePeriod = (index: number) => {
    this.borrower.militaryServicePeriods.splice(index, 1);
    if (this.borrower.militaryServicePeriods.length > 0) {
      this.syncBorrowerFlagsFromFirstPeriod(this.borrower.militaryServicePeriods[0]);
    }
  }

  validate = () => {
    this.militaryServiceForm?.form.markAllAsTouched();
    if (this.militaryServiceForm?.form.valid) {
      return true;
    }
    return false;
  }

  private syncBorrowerFlagsFromFirstPeriod(period: MilitaryServicePeriod): void {
    this.borrower.isActiveDutyMilitary = false;
    this.borrower.onlyNonActivatedReserveOrNationalGuard = false;
    this.borrower.isRetiredDischargedSeparatedFromMilitary = false;

    if (period.militaryStatus === 'ActiveDuty') {
      this.borrower.isActiveDutyMilitary = true;
    } else {
      this.borrower.militaryTourEndDate = null;
    }
    if (period.militaryStatus === 'ReserveNationalGuardNeverActivated') {
      this.borrower.onlyNonActivatedReserveOrNationalGuard = true;
    }
    if (period.militaryStatus === 'Veteran' || period.militaryStatus === 'Separated') {
      this.borrower.isRetiredDischargedSeparatedFromMilitary = true;
    }
  }

  private migrateExistingDataToPeriod(): void {
    const period = new MilitaryServicePeriod();
    period.borrowerId = this.borrower.borrowerId || 0;

    if (this.borrower.isActiveDutyMilitary) {
      period.militaryStatus = 'ActiveDuty';
    } else if (this.borrower.onlyNonActivatedReserveOrNationalGuard) {
      period.militaryStatus = 'ReserveNationalGuardNeverActivated';
    } else if (this.borrower.isRetiredDischargedSeparatedFromMilitary) {
      period.militaryStatus = 'Veteran';
    }

    if (this.borrower.branchOfService) {
      period.branchOfService = this.borrower.branchOfService;
    }
    if (this.borrower.militaryTourEndDate) {
      period.militaryTourEndDate = this.borrower.militaryTourEndDate;
    }

    this.borrower.militaryServicePeriods.push(period);
  }
}
